import { $themeBreakpoints } from '@themeConfig'

export default {
  namespaced: true,
  state: {
    windowWidth: 0,
    shallShowOverlay: false,
    lugniumLate: [],
    savLate: [],
    savTodo: [],
    metrologyLate: [],
  },
  getters: {
    currentBreakPoint: state => {
      const { windowWidth } = state
      if (windowWidth >= $themeBreakpoints.xl) return 'xl'
      if (windowWidth >= $themeBreakpoints.lg) return 'lg'
      if (windowWidth >= $themeBreakpoints.md) return 'md'
      if (windowWidth >= $themeBreakpoints.sm) return 'sm'
      return 'xs'
    },
  },
  mutations: {
    UPDATE_WINDOW_WIDTH(state, val) {
      state.windowWidth = val
    },
    TOGGLE_OVERLAY(state, val) {
      state.shallShowOverlay = val !== undefined ? val : !state.shallShowOverlay
    },
    HYDRATE_LUGNIUMLATE(state, val) {
      state.lugniumLate = val
    },
    HYDRATE_METROLOGYLATE(state, val) {
      state.metrologyLate = val
    },
    HYDRATE_SAVLATE(state, val) {
      state.savLate = val
    },
    HYDRATE_SAVTODO(state, val) {
      state.savTodo = val
    },
  },
  actions: {},
}
